import React, { createContext, useContext, ReactNode } from 'react';
import { cacheService } from '../services/cacheService';
import { invalidateCache } from '../utils/cacheInvalidation';

interface CacheContextType {
  invalidate: typeof invalidateCache;
  clearAll: () => void;
}

const CacheContext = createContext<CacheContextType>({
  invalidate: invalidateCache,
  clearAll: () => {},
});

export const useCache = () => useContext(CacheContext);

interface CacheProviderProps {
  children: ReactNode;
}

export const CacheProvider: React.FC<CacheProviderProps> = ({ children }) => {
  const clearAll = () => {
    cacheService.clear();
  };

  return (
    <CacheContext.Provider
      value={{
        invalidate: invalidateCache,
        clearAll,
      }}
    >
      {children}
    </CacheContext.Provider>
  );
};